import {connect} from 'react-redux';
import ScrollToTopButtonComponent from './ScrollToTopButtonComponent';

export const mapStateToProps = (state) => ({
    translation: state.modules.scrollToTopText,
});

export const ScrollToTopButton = connect(mapStateToProps)(
    ScrollToTopButtonComponent
);

ScrollToTopButton.displayName = 'ScrollToTopButton';

export default ScrollToTopButton;
